import { useWSModal } from "@wingspanhq/fe-component-library";
import { CreateContractorModal } from "./index";

export const useCreateContractorModal = () =>
  useWSModal(CreateContractorModal, {
    title: "Add contractor",
    size: "S"
  });
